// eslint-disable-next-line import/prefer-default-export
export const MEMBERS = "members";
export const ACCESSES = "permissions";
